import React from 'react';
import PropTypes from 'prop-types';
import {
  UploadOutlined,
  ThunderboltFilled,
  ArrowRightOutlined,
} from '@ant-design/icons';
import { ReactComponent as WorkflowIcon } from '../../assets/icons/workflows.svg';
import { ReactComponent as ImportIcon } from '../../assets/icons/box-stack.svg';

import Permissions from '../../auth/Permissions';

const TOOL_CARDS = [
  {
    key: 'automation',
    title: 'Automate workflows',
    description: 'Pair form templates with rules that auto-route approvals, send notifications, and trigger follow-up actions the moment a form is submitted.',
    badge: 'Automation',
    path: '/forms/templates',
    permission: 'FORMS_READ_TEMPLATES',
    icon: WorkflowIcon,
    headerIcon: ThunderboltFilled,
    iconClassName: 'forms-home-tool-card-workflow-icon',
    containerClass: 'forms-home-tool-card-container-automation',
    iconClass: 'forms-home-tool-card-icon--automation',
    badgeClass: 'forms-home-tool-card-badge--automation',
    arrowClass: 'forms-home-tool-card-arrow--automation',
  },
  {
    key: 'import',
    title: 'Bulk import forms',
    description: 'Bring historical forms in from .xlsx or .xls — map columns once and we\'ll catch duplicates and formatting issues for you.',
    badge: 'Migration',
    path: '/forms/import',
    permission: 'FORMS_WRITE',
    icon: UploadOutlined,
    headerIcon: ImportIcon,
    headerIconClassName: 'forms-home-tool-card-badge-import-icon',
    iconClass: 'forms-home-tool-card-icon--import',
    badgeClass: 'forms-home-tool-card-badge--import',
    arrowClass: 'forms-home-tool-card-arrow--import',
  },
];

export default function FormsHomeAdditionalSection({ history }) {
  const visibleCards = TOOL_CARDS.filter(({ permission }) => Permissions.has(permission));

  if (!visibleCards.length) return null;

  return (
    <section className="forms-home-tools">
      <h2 className="forms-home-tools-heading">More form tools</h2>
      <div className="forms-home-tools-grid">
        {visibleCards.map(({
          key,
          title,
          description,
          badge,
          path,
          icon: Icon,
          iconClassName,
          containerClass,
          iconClass,
          badgeClass,
          arrowClass,
          headerIcon: HeaderIcon,
          headerIconClassName,
        }) => (
          <button
            key={key}
            type="button"
            className={`forms-home-tool-card ${containerClass}`}
            onClick={() => history.push(path)}
          >
            <span className={`forms-home-tool-card-icon ${iconClass}`}>
              {iconClassName ? <Icon className={iconClassName} /> : <Icon />}
            </span>
            <div className="forms-home-tool-card-body">
              <span className={`forms-home-tool-card-badge ${badgeClass}`}>
                {headerIconClassName
                  ? <HeaderIcon className={headerIconClassName} />
                  : <HeaderIcon />}
                {badge}
              </span>
              <h3 className="forms-home-tool-card-title">{title}</h3>
              <p className="forms-home-tool-card-description">{description}</p>
            </div>
            <ArrowRightOutlined className={`forms-home-tool-card-arrow ${arrowClass}`} />
          </button>
        ))}
      </div>
    </section>
  );
}

FormsHomeAdditionalSection.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};
